import { render, staticRenderFns } from "./ProjectDeliverable.vue?vue&type=template&id=298e9b9c&"
import script from "./ProjectDeliverable.vue?vue&type=script&lang=js&"
export * from "./ProjectDeliverable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/workflow.dashtogo.com/laravel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('298e9b9c')) {
      api.createRecord('298e9b9c', component.options)
    } else {
      api.reload('298e9b9c', component.options)
    }
    module.hot.accept("./ProjectDeliverable.vue?vue&type=template&id=298e9b9c&", function () {
      api.rerender('298e9b9c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/csmworkflow/js/views/ProjectDeliverable.vue"
export default component.exports